import { render, staticRenderFns } from "./PlatArticle.vue?vue&type=template&id=95d4ad96&scoped=true"
import script from "./PlatArticle.vue?vue&type=script&lang=js"
export * from "./PlatArticle.vue?vue&type=script&lang=js"
import style0 from "./PlatArticle.vue?vue&type=style&index=0&id=95d4ad96&prod&lang=css"
import style1 from "./PlatArticle.vue?vue&type=style&index=1&id=95d4ad96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d4ad96",
  null
  
)

export default component.exports